module.exports = __webpack_public_path__ + "static/media/hexagons.6f6ee8df.svg";